

define(['squid/index', './directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-member-sepa.sepaAgreement.route', ['squid', 'xo-member-sepa.sepaAgreement.directive']).factory('$XOSepaAgreementRoute', function ($ComponentRoute) {
        return $ComponentRoute.extend('XOSepaAgreementRoute', {
            name: 'sepaAgreement',

            directive: 'xo-sepa-agreement',
            titleContent: 'directDebitAgreement.sepaTitle',

            trackingData: {
                fptiState: 'sepa_agreement',
                buzname: {
                    'fullpage': {
                        'pagename': '%::sepa_agreement',
                        'pagename2': '%::sepa_agreement:member:hermes:',
                        'version': 'member:%:'
                    }
                }
            },

            loginRequired: true,

            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/member-sepa/sepaAgreement/route.js
// module id = ./components/xo-wallet-components/src/member-sepa/sepaAgreement/route.js
// module chunks = 1